import { render } from 'react-dom'
import { App } from './App'
import pjson from './package.alias.json'
import * as serviceWorker from './serviceWorker'
import 'semantic-ui-css/semantic.min.css'
import 'react-toastify/dist/ReactToastify.css'

import { Config } from './types/config'

export default class AppSetup {
  constructor(private appContainerId: string, private config: Config) {}

  setup() {
    console.log(`You are running ${pjson.name} v${pjson.version}`)
    const InitializedApp = App(this.config)
    render(<InitializedApp />, document.getElementById(this.appContainerId))
  }
}

const namespace = 'PackageManager'
;(window as any)[namespace] = AppSetup

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
